import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import { api } from "../services/api";
import { resolveProductImage } from "../utils/productAssets";
import { renderHtml } from "../utils/renderHtml";

const injectStyles = () => {
  if (document.getElementById("bn-styles-v7")) return;
  const s = document.createElement("style");
  s.id = "bn-styles-v7";
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;900&family=DM+Sans:wght@400;500;600;700&display=swap');

    .bns * { box-sizing: border-box; }
    .bns { padding: 18px 0 28px; background: #f0f4f8; font-family: 'DM Sans', sans-serif; }
    .bns a { text-decoration: none; }
    .bns .container { max-width: 1580px; }
    @keyframes bns-up { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
    @keyframes bns-pulse { 0%,100% { box-shadow:0 0 0 0 rgba(255,255,255,.35); } 50% { box-shadow:0 0 0 7px rgba(255,255,255,0); } }

    .bns-car {
      min-height: 450px; height: 100%; position: relative; overflow: hidden; color: #fff;
      display: flex; flex-direction: column; border-radius: 22px; padding: 30px 28px 0;
      background: linear-gradient(138deg,#3991D5 0%,#1a6db5 58%,#0e4d8a 100%);
      box-shadow: 0 18px 55px rgba(57,145,213,.34), 0 3px 14px rgba(57,145,213,.16);
    }
    .bns-car::before { content:''; position:absolute; top:-90px; right:-90px; width:300px; height:300px; border-radius:50%; background:rgba(255,255,255,.055); }
    .bns-sli { display:flex; flex-direction:column; flex:1; animation:bns-up .36s ease both; }
    .bns-badge {
      display:inline-flex; align-items:center; gap:6px; width:fit-content; margin-bottom:14px; padding:5px 14px;
      border:1.5px dashed rgba(255,255,255,.52); border-radius:6px; color:rgba(255,255,255,.92);
      font-size:10px; font-weight:800; letter-spacing:.08em; text-transform:uppercase; animation:bns-pulse 2.8s ease-in-out infinite;
    }
    .bns-badge::before { content:''; width:6px; height:6px; border-radius:50%; background:#7ee8a2; }
    .bns-h1 { margin:0 0 10px; color:#fff; font-family:'Syne',sans-serif; font-size:clamp(0.85rem,3vw,1.65rem); font-weight:900; line-height:1.06; letter-spacing:-.03em; }
    .bns-pdesc { max-width:90%; margin:0; color:rgba(255,255,255,.82); font-size:13px; line-height:1.65; }
    .bns-cbtn {
      display:inline-flex; align-items:center; justify-content:center; width:fit-content; height:44px; margin-top:24px; padding:0 28px;
      border-radius:22px; background:#fff; color:#1a6db5; font-size:14px; font-weight:800; box-shadow:0 4px 18px rgba(0,0,0,.14);
      transition:transform .18s ease, box-shadow .18s ease;
    }
    .bns-cbtn:hover { color:#1a6db5; transform:translateY(-2px); box-shadow:0 10px 28px rgba(0,0,0,.22); }
    .bns-pimg-wrap { margin-top:auto; align-self:flex-end; width:fit-content; position:relative; z-index:2; }
    .bns-pimg { width:100%; border-radius:12px; margin-top:10px; height:auto; max-height:220px; object-fit:contain; display:block; filter:drop-shadow(0 14px 22px rgba(0,0,0,.18)); }
    .bns-dots { display:flex; gap:8px; padding:16px 0 22px; position:relative; z-index:3; }
    .bns-dot { width:7px; height:7px; border:0; border-radius:4px; padding:0; cursor:pointer; background:rgba(255,255,255,.35); transition:width .25s ease, background .25s ease; }
    .bns-dot.on { width:22px; background:#fff; }

    .bns-special, .bns-hot, .bns-picks {
      background:#fff; border:1px solid #e6edf7; border-radius:20px; box-shadow:0 3px 16px rgba(15,23,42,.045);
    }
    .bns-special {
      height:100%; overflow:hidden; position:relative; display:flex; flex-direction:column; align-items:center; text-align:center;
      padding:24px 22px 0; background:linear-gradient(145deg,#5bc4f8 0%,#2aaee8 48%,#1a95d4 100%); transition:transform .22s ease, box-shadow .22s ease;
    }
    .bns-special:hover { transform:translateY(-4px); box-shadow:0 22px 52px rgba(50,180,240,.32); }
    .bns-sp-label { margin:0 0 5px; color:rgba(255,255,255,.84); font-size:13px; font-style:italic; }
    .bns-sp-title { width:100%; margin:0 0 6px; color:#fff; font-family:'Syne',sans-serif; font-size:clamp(1.45rem,2.3vw,2.25rem); font-weight:900; line-height:1.06; letter-spacing:-.02em; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
    .bns-sp-price { margin:0 0 14px; color:rgba(255,255,255,.9); font-size:14px; font-weight:800; }
    .bns-sp-btn { display:inline-flex; align-items:center; border:1.5px solid rgba(255,255,255,.48); border-radius:20px; padding:5px 18px; color:#fff; font-size:12px; font-weight:800; background:rgba(255,255,255,.18); }
    .bns-sp-img { width:fit-content; margin-top:auto; margin-bottom:10px; }
    .bns-sp-img img { width:100%; height:150px; object-fit:contain; display:block; border-radius:12px; }

    .bns-hot { height:100%; padding:22px 20px; }
    .bns-hot-hd, .bns-picks-hd { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:16px; }
    .bns-hot-ttl, .bns-picks-ttl { color:#1a202c; font-family:'Syne',sans-serif; font-size:16px; font-weight:800; }
    .bns-view-all, .bns-shop-more { color:#3991D5; font-size:12px; font-weight:800; }
    .bns-hot-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; }
    .bns-hot-item { display:flex; flex-direction:column; align-items:center; gap:7px; min-width:0; transition:transform .18s ease; }
    .bns-hot-item:hover { transform:translateY(-4px); }
    .bns-hot-box { width:70px; height:78px; border:1px solid #e4edf8; border-radius:13px; background:#fff; display:flex; align-items:center; justify-content:center; padding:6px; }
    .bns-hot-box img { width:100%; height:100%; object-fit:contain; }
    .bns-hot-lbl { width:100%; margin:0; color:#475569; font-size:10.5px; font-weight:700; line-height:1.25; text-align:center; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
    .bns-hot-count { color:#3991D5; font-size:10px; font-weight:900; }

    .bns-picks { margin-top:14px; padding:18px 22px 20px; }
    .bns-picks-grid { display:grid; grid-template-columns:repeat(4,1fr); border-top:1px solid #f0f4fa; }
    .bns-pick { display:flex; align-items:center; gap:10px; min-width:0; padding:14px 12px; color:inherit; transition:background .18s ease; }
    .bns-pick:not(:last-child) { border-right:1px solid #f0f4fa; }
    .bns-pick:hover { background:#f5faff; color:inherit; }
    .bns-pick-imgbox { width:54px; height:54px; flex-shrink:0; border:1px solid #e4edf8; border-radius:10px; display:flex; align-items:center; justify-content:center; padding:4px; background:#fff; }
    .bns-pick-imgbox img { width:100%; height:100%; object-fit:contain; }
    .bns-pick-info { min-width:0; flex:1; display:flex; flex-direction:column; gap:3px; }
    .bns-pick-name { margin:0; color:#2196f3; font-size:14px; font-weight:800; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .bns-pick-meta { margin:0; color:#64748b; font-size:11px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .bns-pick-prices { display:flex; align-items:center; gap:6px; }
    .bns-pick-was { color:#94a3b8; font-size:11px; text-decoration:line-through; }
    .bns-pick-now { color:#0ea5e9; font-size:13px; font-weight:900; }
    .bns-empty { height:100%; min-height:180px; display:flex; align-items:center; justify-content:center; color:#64748b; font-weight:700; text-align:center; }
    .bns-skeleton { position:relative; overflow:hidden; background:#e8eef7; border-radius:16px; min-height:180px; }
    .bns-skeleton::after { content:''; position:absolute; inset:0; transform:translateX(-100%); background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent); animation:bns-shimmer 1.2s infinite; }
    @keyframes bns-shimmer { 100% { transform:translateX(100%); } }

    @media (max-width:991px) and (min-width:768px) {
      .bns-picks-grid { grid-template-columns:repeat(2,1fr); }
      .bns-pick:nth-child(2) { border-right:0; }
      .bns-pick:nth-child(1), .bns-pick:nth-child(2) { border-bottom:1px solid #f0f4fa; }
    }
    @media (max-width:767px) {
      .bns { padding:10px 0 20px; }
      .bns-car { min-height:310px; border-radius:18px; padding:22px 20px 0; }
      .bns-h1 { font-size:1.75rem; }
      .bns-pdesc { font-size:12px; }
      .bns-cbtn { height:40px; padding:0 22px; font-size:13px; margin-top:18px; }
      .bns-pimg-wrap { width:68%; }
      .bns-hot-grid { gap:8px; }
      .bns-hot-box { width:56px; height:58px; }
      .bns-picks-grid { grid-template-columns:repeat(2,1fr); }
      .bns-pick:nth-child(2) { border-right:0; }
      .bns-pick:nth-child(1), .bns-pick:nth-child(2) { border-bottom:1px solid #f0f4fa; }
    }
    @media (max-width:420px) {
      .bns-hot-grid, .bns-picks-grid { grid-template-columns:repeat(2,1fr); }
      .bns-pick { border-right:0 !important; border-bottom:1px solid #f0f4fa; }
    }
  `;
  document.head.appendChild(s);
};

const money = (value) => `$${Number(value || 0).toFixed(2)}`;
const productPath = (product) => `/products/${encodeURIComponent(product?.slug || product?.sku || product?._id)}`;

function productSummary(product) {
  return product?.subcategory || product?.category || product?.brandLine || product?.sku || "Industrial sewing part";
}

function BannerSkeleton() {
  return (
    <section className="bns">
      <div className="container">
        <Row gutter={[14, 14]}>
          <Col xs={24} md={8}><div className="bns-skeleton" style={{ minHeight: 450 }} /></Col>
          <Col xs={24} md={16}>
            <Row gutter={[14, 14]}>
              <Col xs={24} sm={12}><div className="bns-skeleton" /></Col>
              <Col xs={24} sm={12}><div className="bns-skeleton" /></Col>
            </Row>
            <div className="bns-skeleton" style={{ minHeight: 120, marginTop: 14 }} />
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default function Banner() {
  useEffect(() => { injectStyles(); }, []);

  const [loading, setLoading] = useState(true);
  const [slides, setSlides] = useState([]);
  const [categories, setCategories] = useState([]);
  const [picks, setPicks] = useState([]);
  const [special, setSpecial] = useState(null);
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    async function loadBanner() {
      setLoading(true);
      try {
        const [machines, featured, popular, topSelling, categoryData] = await Promise.all([
          api.get("/listings?section=machines&limit=3"),
          api.get("/listings?section=featured&limit=3"),
          api.get("/listings?section=popular&limit=1"),
          api.get("/listings?section=topSelling&limit=4"),
          api.get("/categories"),
        ]);

        if (!mounted) return;

        const machineProducts = machines.products || [];
        const featuredProducts = featured.products || [];
        const topProducts = topSelling.products || [];
        const slideProducts = machineProducts.length ? machineProducts : featuredProducts;

        setSlides(slideProducts.slice(0, 3));
        setSpecial((popular.products || [])[0] || featuredProducts[0] || machineProducts[0] || topProducts[0] || null);
        setPicks((topProducts.length ? topProducts : featuredProducts).slice(0, 4));
        setCategories((categoryData.categories || []).slice(0, 8));
      } catch (error) {
        if (mounted) {
          setSlides([]);
          setSpecial(null);
          setPicks([]);
          setCategories([]);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadBanner();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    setCurrent(0);
  }, [slides.length]);

  const startAuto = useCallback(() => {
    clearInterval(timerRef.current);
    if (slides.length <= 1) return;
    timerRef.current = setInterval(() => {
      setCurrent((value) => (value + 1) % slides.length);
    }, 5200);
  }, [slides.length]);

  const stopAuto = useCallback(() => {
    clearInterval(timerRef.current);
  }, []);

  useEffect(() => {
    startAuto();
    return () => stopAuto();
  }, [startAuto, stopAuto]);

  const slide = useMemo(() => {
    if (!slides.length) return null;
    return slides[current % slides.length];
  }, [current, slides]);

  if (loading) return <BannerSkeleton />;

  if (!slide && !special && !categories.length && !picks.length) {
    return null;
  }

  return (
    <section className="bns">
      <div className="container">
        <Row gutter={[14, 14]} align="stretch">
          <Col xs={24} md={8}>
            {slide ? (
              <div className="bns-car" onMouseEnter={stopAuto} onMouseLeave={startAuto}>
                <div key={slide._id || current} className="bns-sli">
                  <div style={{ position: "relative", zIndex: 2 }}>
                    <span className="bns-badge">{productSummary(slide)}</span>
                    <h1 className="bns-h1">
                      {slide.name?.length > 55
                        ? `${slide.name.slice(0, 55)}...`
                        : slide.name}
                    </h1>
                    <p className="bns-pdesc" dangerouslySetInnerHTML={renderHtml(slide.shortDescription)} />
                    <Link className="bns-cbtn" to={productPath(slide)}>View Product</Link>
                  </div>
                  <div className="bns-pimg-wrap">
                    <img className="bns-pimg" src={resolveProductImage(slide.image)} alt={slide.name} />
                  </div>
                </div>
                <div className="bns-dots">
                  {slides.map((item, index) => (
                    <button
                      key={item._id || item.sku || index}
                      className={`bns-dot${index === current ? " on" : ""}`}
                      onClick={() => setCurrent(index)}
                      aria-label={`Show ${item.name}`}
                      type="button"
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="bns-car"><div className="bns-empty">Products will appear here when active inventory is available.</div></div>
            )}
          </Col>

          <Col xs={24} md={16}>
            <Row gutter={[14, 14]}>
              <Col xs={24} sm={12} style={{ display: "flex" }}>
                {special ? (
                  <Link className="bns-special" to={productPath(special)} style={{ width: "100%" }}>
                    <p className="bns-sp-label">Featured inventory</p>
                    <h2 className="bns-sp-title">{special.name}</h2>
                    <p className="bns-sp-price">{money(special.price)}</p>
                    <span className="bns-sp-btn">Shop Now</span>
                    <div className="bns-sp-img">
                      <img src={resolveProductImage(special.image)} alt={special.name} />
                    </div>
                  </Link>
                ) : (
                  <div className="bns-special bns-empty" style={{ width: "100%" }}>No featured product selected.</div>
                )}
              </Col>

              <Col xs={24} sm={12} style={{ display: "flex" }}>
                <div className="bns-hot" style={{ width: "100%" }}>
                  <div className="bns-hot-hd">
                    <span className="bns-hot-ttl">Hot Categories</span>
                    <Link className="bns-view-all" to="/categories">View all</Link>
                  </div>
                  {categories.length ? (
                    <div className="bns-hot-grid">
                      {categories.map((category) => (
                        <Link
                          key={category.slug || category.name}
                          className="bns-hot-item"
                          to={`/all-products?categorySlug=${encodeURIComponent(category.slug)}`}
                        >
                          <div className="bns-hot-box">
                            <img src={resolveProductImage(category.image)} alt={category.name} />
                          </div>
                          <p className="bns-hot-lbl">{category.name}</p>
                          <span className="bns-hot-count">{category.count || 0} items</span>
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <div className="bns-empty">Categories will appear after they are created.</div>
                  )}
                </div>
              </Col>
            </Row>

            <div className="bns-picks">
              <div className="bns-picks-hd">
                <span className="bns-picks-ttl">Best Picks Of The Week</span>
                <Link to="/all-products?section=topSelling" className="bns-shop-more">Shop More</Link>
              </div>
              {picks.length ? (
                <div className="bns-picks-grid">
                  {picks.map((product) => (
                    <Link key={product._id || product.sku} className="bns-pick" to={productPath(product)}>
                      <div className="bns-pick-imgbox">
                        <img src={resolveProductImage(product.image)} alt={product.name} />
                      </div>
                      <div className="bns-pick-info">
                        <p className="bns-pick-name">{product.name}</p>
                        <p className="bns-pick-meta">{productSummary(product)}</p>
                        <div className="bns-pick-prices">
                          {product.compareAtPrice > product.price && <span className="bns-pick-was">{money(product.compareAtPrice)}</span>}
                          <span className="bns-pick-now">{money(product.price)}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="bns-empty">Top selling products will appear after orders are recorded.</div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
